import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, shape, oneOfType, string, arrayOf } from "prop-types";
import { Form, Formik, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import * as numberUtils from "util/number";
import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";
import MainContainer from "pages/_components/MainContainer";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import CustomProductHead from "pages/_components/CustomProductHead";
import Button from "pages/_components/Button";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import I18n from "pages/_components/I18n";
import Drawer from "pages/_components/Drawer/Drawer";
import Credential from "pages/_components/fields/credentials/Credential";
import Check from "pages/_components/fields/Checkbox";
import { isIOS } from "react-device-detect";
import Notification from "pages/_components/Notification";
import CuotasDetail from "../_components/CuotasDetail";
import GridTable from "../../_components/GridTable/GridTable";

const UnsecuredLoanTokenTermsConditions = ({
    isDesktop,
    fetching,
    loanSimulation,
    loanType,
    loanApplicationInProgress,
}) => {
    const dispatch = useDispatch();
    const [checkboxState, setCheckboxState] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);
    const [openSidebarDetail, setOpenSidebarDetail] = useState(false);

    const renderHeader = () => (
        <CustomProductHead
            defaultTitle={`Confirmá tu ${i18n.get(`unsecured.loans.${loanType}.title`)}`}
            backLinkTo="/requestUnsecuredLoan"
            // addLinkToLabel="deposits.new"
            // addLinkTo="/applyForLoan"
            className="deposits">
            <div className="toolbar-item view-title">
                <ViewTitle defaultValue={`Confirmá tu ${i18n.get(`unsecured.loans.${loanType}.title`)}`} />
            </div>
        </CustomProductHead>
    );

    const infoLoanDetails = () => (
        <GridTable className="equivalent-total-balance">
            <GridTable.Container columns={3} columnsTemplate="fixed">
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={i18n.get(
                            "unsecured.loans.confirm.detailLoan.amountToBeCredited",
                            "Monto a acreditar",
                        )}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.totalOperationAmount)}
                            />
                        }
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.requestedAmount", "Monto solicitado")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.totalOperationAmount)}
                            />
                        }
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText={i18n.get(
                            "unsecured.loans.confirm.debitCreditAccount",
                            "Cuenta de acreditación y débito",
                        )}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.accountLabel}
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.duration", "Duración del préstamo")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.duration}
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.amortizationType", "Sistema de amortización")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={i18n.get(`unsecured.loans.types.${loanSimulation.subproductId}`)}
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 6}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.amountOfInstallments", "Cantidad de cuotas")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.installmentList.length}
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={isDesktop ? 3 : 7}>
                    <CustomData
                        titleText={i18n.get(
                            "unsecured.loans.confirm.installmentsExpirationDate",
                            "Fecha de vencimiento de cuotas",
                        )}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.paymentDate}
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 3 : 8}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.first.installment", "Primera cuota")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.firstPureInstallment)}
                            />
                        }
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 3 : 9}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.last.installment", "Última cuota")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.lastPureInstallment)}
                            />
                        }
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 10}>
                    <CustomData
                        titleText={i18n.get(
                            "unsecured.loans.confirm.commissions",
                            "Comisiones por otorgamiento del Préstamo",
                        )}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.commission)}
                            />
                        }
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    const infoRates = () => (
        <GridTable className="equivalent-total-balance">
            <GridTable.Container columns={3} columnsTemplate="fixed">
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.type", "Tipo de tasa")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.rateType}
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.tna", "Tasa nominal anual (TNA)")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.tna}
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.tea", "Tasa efectiva anual (TEA)")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.tea}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                    <CustomData
                        titleText={i18n.get(
                            "unsecured.loans.simulation.rate.cftea",
                            "Costo Financiero Total Efectivo Anual (CFTEA)",
                        )}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.cftSIVA}
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.simulation.rate.cftea.iva", "CFTEA + IVA")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.cftCIVA}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    const infoRetentions = () => (
        <GridTable className="equivalent-total-balance">
            <GridTable.Container columns={3} columnsTemplate="fixed">
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.IIBB", "Percepción de IIBB")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.charges.iibbPerception)}
                            />
                        }
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.iva", "IVA")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.charges.iva)}
                            />
                        }
                    />
                </GridTable.Data>

                <div style={{ paddingBottom: "12px" }} />
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.ivaPers", "Percepción IVA")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount
                                currency="ARS"
                                quantity={numberUtils.formatAmountStrDouble(loanSimulation.charges.ivaPerception)}
                            />
                        }
                    />
                </GridTable.Data>

                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                    <CustomData
                        titleText={i18n.get("unsecured.loans.confirm.IIBBJurisdiction", "Jurisdicción de IIBB")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={loanSimulation.charges.jurisdiction}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    const cuotasInfo = () => (
        <Drawer
            openSidebar={openSidebarDetail}
            onClose={onClose}
            isFullHeight={!isDesktop}
            enableCloseButton={!!isDesktop}>
            <CuotasDetail
                installmentList={loanSimulation.installmentList}
                isDesktop={isDesktop}
                handleClose={onClose}
                openForm={openSidebarDetail}
            />
        </Drawer>
    );

    const handleCheckboxChange = () => {
        setCheckboxError(false);
        setCheckboxState(!checkboxState);
    };

    const handleDetail = () => {
        setOpenSidebarDetail(true);
    };
    const onClose = () => {
        setOpenSidebarDetail(false);
    };

    const handleConfirm = (values) => {
        if (values) {
            const params = {
                amount: {
                    quantity: loanSimulation.totalAmount,
                    currency: "ARS",
                },
                loanSimulation,
                _otp: values.credential,
            };
            dispatch(loansActions.unsecuredLoansApplicationSend(params));
        }
    };

    const formikProps = {
        initialValues: {
            credential: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                credential: Yup.string(),
            }),
        onSubmit: (values) => {
            handleConfirm(values);
        },
    };

    return (
        <>
            <Notification scopeToShow="unsecured.loan" />
            {renderHeader()}
            {cuotasInfo()}
            <MainContainer showLoader={fetching} className="loans">
                <Formik {...formikProps}>
                    {() => (
                        <Form id="unsecuredLoanForm.confirm.validateToken" className="box">
                            <div style={{ paddingBottom: "5px" }} />
                            <Row className="form-background">
                                <div style={{ padding: "0px 24px 0px 24px" }}>
                                    <I18n component="h3" id="unsecured.loans.confirm.detailLoan.title" />
                                    {infoLoanDetails()}
                                    <div style={{ paddingBottom: "20px" }} />
                                    <I18n component="h3" id="unsecured.loans.simulation.rate.subtitle" />
                                    {infoRates()}
                                    <div style={{ paddingBottom: "20px" }} />
                                    <I18n component="h3" id="unsecured.loans.confirm.retentions.title" />
                                    {infoRetentions()}
                                    <div style={{ paddingBottom: "12px" }} />
                                    <Col className="mt-8">
                                        <Button
                                            image="images/figma/icon/arrow-right.svg"
                                            bsStyle="link"
                                            style={{ flexDirection: "row-reverse", paddingLeft: "70%" }}
                                            label="unsecured.loans.simulation.installment.detail"
                                            onClick={() => handleDetail()}
                                        />
                                    </Col>
                                </div>
                            </Row>

                            <Row className="form-actions">
                                <Col md={4} className="mt-8">
                                    <div className="d-flex align-items-center">
                                        <div style={isIOS ? { width: "var(--space-9)" } : null}>
                                            <Check
                                                hideLabel
                                                name="termsAndConditios"
                                                onChange={handleCheckboxChange}
                                                checked={checkboxState}
                                                error={checkboxError ? "Campo requerido" : ""}
                                            />
                                        </div>
                                        <div className="d-flex pb-4">
                                            <div className={isIOS ? "whitespace-nowrap pr-3" : "pr-3"}>
                                                {i18n.get("unsecuredLoan.accept")}
                                            </div>
                                            <div
                                                aria-hidden="true"
                                                className={isIOS ? "whitespace-nowrap btn-link" : "btn-link"}
                                                onClick={() => {
                                                    dispatch(loansActions.downloadUnsecuredLoansApplicationTerms());
                                                }}>
                                                {i18n.get("global.termAndConditions")}
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <div className="container--alert" role="alert">
                                    <div className="alert alert-info">
                                        <CustomData
                                            icon="information_fill.svg"
                                            titleText={i18n.get("unsecured.loans.simulation.disclaimer2")}
                                            keepSpaceIfNoValue={false}
                                        />
                                    </div>
                                    <div style={{ paddingBottom: "10px" }} />
                                </div>

                                <Col xs={12} md={4} mdOffset={2}>
                                    <Field
                                        component={Credential}
                                        idForm="form.credential"
                                        name="credential"
                                        type="otp"
                                        labelText="form.credential.token.label"
                                        placeholderText="Ej: 120573"
                                    />
                                </Col>
                                <Col xs={12} md={4} mdOffset={6} className="align-items-end">
                                    <div className="form-group hidden-label">
                                        <div className="button-group">
                                            <Button
                                                block
                                                type="submit"
                                                label="global.confirm"
                                                bsStyle="primary"
                                                loading={loanApplicationInProgress}
                                                disabled={!checkboxState}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

UnsecuredLoanTokenTermsConditions.propTypes = {
    isDesktop: oneOfType([string, bool]).isRequired,
    loanSimulation: shape({}).isRequired,
    loanType: arrayOf(string).isRequired,
    loanApplicationInProgress: bool.isRequired,
};

const mapStateToProps = (state) => ({
    fetching: loansSelectors.getFetching(state),
    loanApplicationInProgress: loansSelectors.getLoanApplicationInProgress(state),
    loanSimulation: loansSelectors.getLoanSimulation(state),
    loanType: state.loans.loanType,
});

export default connect(mapStateToProps)(UnsecuredLoanTokenTermsConditions);
